import React from 'react';
import { FormattedMessage } from 'react-intl';
import useApiMutation from '../useApiMutation';
import useMessage from '../../useMessage';

const useDetectShowCoverColors = () => {
  const { message } = useMessage();

  const mutation = useApiMutation({
    getRequestUrl: ({ showId }) => `/shows/${showId}/cover-colors`,
    method: 'GET',
    onError: () => {
      message.danger({
        content: <FormattedMessage defaultMessage="Could not fetch colors from image" />,
      });
    },
  });

  return {
    getCoverColor: mutation.mutate,
    isCoverColorsLoading: mutation.isLoading,
    isGetCoverColorsError: mutation.isError,
    isGetCoverColorsSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useDetectShowCoverColors;
